import { Input } from '@builder.io/sdk';

import { buttonFields } from 'molecules/Button/config';
import { iconIds } from 'molecules/Icon/types';
import imageField from 'molecules/Image/config';

import { idField } from 'utils/builder/fields';

const iconCardFields = [
  idField,
  {
    name: 'iconId',
    type: 'string',
    defaultValue: 'facebook',
    enum: iconIds,
    helperText: 'Choose an icon from the available set (e.g., Facebook, Twitter, LinkedIn).',
  },
  imageField('image'),
  {
    name: 'title',
    type: 'string',
    defaultValue: 'Default Title',
    helperText: 'Main title of the card.',
  },
  {
    name: 'subhead',
    type: 'string',
    helperText: 'Optional short subheading shown under the title.',
  },
  {
    name: 'description',
    type: 'richText',
    defaultValue: '<p>Default description text</p>',
    helperText: 'Supporting text for the card. Can include links, bold, etc.',
  },
  {
    name: 'useStandardBullets',
    type: 'boolean',
    defaultValue: false,
    helperText:
      'When enabled, applies standard list styling to unordered lists inside the description (disc bullets, left indent).',
  },
  {
    name: 'button',
    type: 'object',
    subFields: buttonFields,
    helperText: 'Optional button with link and styles.',
  },
  {
    name: 'iconSize',
    type: 'string',
    defaultValue: 'md',
    enum: [
      { label: 'S', value: 'sm' },
      { label: 'M', value: 'md' },
      { label: 'L', value: 'lg' },
      { label: 'XL', value: 'xl' },
    ],
    helperText: 'Controls the display size of the icon inside the card.',
  },
  {
    name: 'isIcon',
    type: 'boolean',
    defaultValue: true,
    helperText:
      'If enabled (default), the card shows either the selected icon or image. Disable it to render custom art/content instead.',
  },
  {
    name: 'customTextHeading',
    type: 'richText',
    helperText:
      'Custom rich text rendered in place of the icon/image when "isIcon" is disabled. Useful for numbers or custom labels.',
  },
  {
    name: 'pinButtonToBottom',
    type: 'boolean',
    defaultValue: true,
    helperText:
      'When enabled, the button is pinned to the bottom of the card. Disable to let it sit closer to the description.',
  },
] as const satisfies DeepReadonly<Input[]>;

export type IconCardConfigProps = GenerateBuilder<typeof iconCardFields>;

export default iconCardFields;
